/**
 * QFR Header — sticky (page-wrapper + window) + mobile drawer
 * Horizon desktop scrolls .page-wrapper, not window — listen to both.
 */
(function () {
  const STICKY_OFFSET = 8;

  function getScrollY() {
    const wrapper = document.querySelector('.page-wrapper');
    if (wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1) {
      return wrapper.scrollTop;
    }
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function initHeader(root) {
    if (root.dataset.qfrInit) return;
    root.dataset.qfrInit = 'true';

    const toggle = root.querySelector('[data-qfr-drawer-toggle]');
    const drawer = root.querySelector('[data-qfr-drawer]');
    const closers = root.querySelectorAll('[data-qfr-drawer-close]');
    const headerGroup = document.querySelector('#header-group');
    const pageWrapper = document.querySelector('.page-wrapper');

    const setSticky = () => {
      const sticky = getScrollY() > STICKY_OFFSET;
      root.classList.toggle('is-sticky', sticky);
      if (headerGroup) headerGroup.classList.toggle('is-sticky', sticky);
    };

    const openDrawer = () => {
      root.classList.add('is-drawer-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (drawer) drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };

    const closeDrawer = () => {
      root.classList.remove('is-drawer-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };

    if (toggle) {
      toggle.addEventListener('click', () => {
        if (root.classList.contains('is-drawer-open')) closeDrawer();
        else openDrawer();
      });
    }

    closers.forEach((el) => el.addEventListener('click', closeDrawer));

    root.querySelectorAll('.qfr-header__drawer-link, .qfr-header__drawer-cta').forEach((el) => {
      el.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1024) closeDrawer();
    });

    window.addEventListener('scroll', setSticky, { passive: true });
    if (pageWrapper) {
      pageWrapper.addEventListener('scroll', setSticky, { passive: true });
    }
    setSticky();
  }

  function initAll() {
    document.querySelectorAll('[data-qfr-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
